import { useState } from "react";
import { monthCells, publishUrgency, topicsOnDate } from "../domain/calendar";
import { matchesQuery, topicsForAccount } from "../domain/selectors";
import { shiftMonth, todayInShanghai } from "../domain/time";
import { plainText } from "../lib/text";
import { useApp } from "../state/store";
import type { Topic } from "../types";
import { EmptyState } from "../components/EmptyState";

const WEEKDAYS = ["一", "二", "三", "四", "五", "六", "日"];

export function CalendarView({ onOpen }: { onOpen?: (topic: Topic) => void }) {
  const app = useApp();
  const today = todayInShanghai();
  const [cursor, setCursor] = useState(() => {
    const [year, month] = today.split("-").map(Number);
    return { year: year || 2026, monthIndex: (month || 1) - 1 };
  });
  const cells = monthCells(cursor.year, cursor.monthIndex);
  const topics = topicsForAccount(app.state.topics, app.accountId).filter((topic) => matchesQuery(topic, app.query));
  const dated = topics.filter((topic) => topic.plannedPublishDate && topic.status !== "不做");

  return (
    <div className="stack">
      <div className="calendar-toolbar">
        <button
          type="button"
          className="button"
          onClick={() => setCursor((current) => shiftMonth(current.year, current.monthIndex, -1))}
        >
          上个月
        </button>
        <strong>
          {cursor.year}年{cursor.monthIndex + 1}月
        </strong>
        <button
          type="button"
          className="button"
          onClick={() => setCursor((current) => shiftMonth(current.year, current.monthIndex, 1))}
        >
          下个月
        </button>
      </div>
      {dated.length === 0 ? (
        <EmptyState
          compact
          title="还没有计划发布日"
          body="选题库里如果有「计划发布日」，同步后会显示在日历上。没有这个属性时，日历保持空白。"
        />
      ) : null}
      <div className="calendar">
        {WEEKDAYS.map((day) => (
          <div key={day} className="weekday">
            {day}
          </div>
        ))}
        {cells.map((cell, index) => {
          const items = cell.date ? topicsOnDate(topics, cell.date) : [];
          return (
            <div key={cell.date ?? `empty-${index}`} className={cell.date === today ? "day is-today" : "day"}>
              <span>{cell.day ?? ""}</span>
              {items.map((topic) => {
                const urgency = publishUrgency(topic.plannedPublishDate, topic.status, today);
                return (
                  <button
                    key={topic.id}
                    type="button"
                    className={`cal-item urgency-${urgency}`}
                    title={plainText(topic.title)}
                    onClick={() => (onOpen ? onOpen(topic) : topic.status === "待审阅" ? app.openReview(topic.id) : app.openTopic(topic.id))}
                  >
                    {plainText(topic.title)}
                  </button>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}
